
<script>
import VueRecaptcha from 'vue-recaptcha';
import Vue from 'vue'
import VeeValidate from 'vee-validate';
import Datepicker from 'vuejs-datepicker';
import VueSession from 'vue-session'
import 'whatwg-fetch'
import axios from 'axios'
import  OnlineFormServices  from './services/OnlineFormServices'

Vue.component('Sharing', require('../shared/sharing/Sharing.vue').default);
Vue.use(VueSession)

export default {
  name: 'draw-online-form',
  data() {
    return {
      submitted:false,
      showForm:false,
      captchaImage:null,
      isLoading:false,
      backendErrorMsg:null,
      successMsg:null,
      googleReCaptchaResponse:null,
      rememberme:false,
      title:null,
      image:'lala',
      sitekey: window.mepaConfig.siteKey,
      isFalse:false,
      model: {
      },
      dict :{
       custom: {
       }
     },
     onlineFormServices:new OnlineFormServices(),
     captcha: new Vue(),
   }
 },
 components: {
  Datepicker,
  VueRecaptcha 
},

created: function() {
  this.isLoading =true;
  
  this.onlineFormServices.getLogin().then(response => {
    this.isLoading =false;
    if(response.data.success && response.data.success===true){
      this.showForm = true;
      this.$session.set('token',response.data.token);
      
    }else{
      if(response.data.redirect && response.data.redirect===true) {
        window.location.href= response.data.message;
      }else{
        this.backendErrorMsg = response.data.message;
        this.getBackendErrorMsg(response);
      }
    }
  })
  .catch(e => {
    this.isLoading =false;
    if(e.response){
      this.getBackendErrorMsg(e.response);
    }
 })
},

methods: {
  async onSubmit(){
    this.submitted = true;
    this.$validator.validateAll().then((result) => {
      if (!result) {
        return;
      }
      var serialize_frm=[]
      if(this.googleReCaptchaResponse){
        this.model['captcha'] = this.googleReCaptchaResponse;  
      }else{
        this.backendErrorMsg = window.mepaConfig.captchaErrorMsg;
      }

      serialize_frm=Object.entries(this.model).map(function(entry){
       if (entry[0] != "promoId" && entry[0] != "captchaImage" && entry[0] !='file') {
        let value = entry[1];
        
        if ( Object.prototype.toString.call(value) === "[object Date]" ) {
          if ( !isNaN( value.getTime() )){
            value.setHours(0,0,0,0);
          }
        }

        var obj = {
          "key":entry[0],
          "value":value
        }
        return obj;
      }
     });
     let finalFormValue = [];
     serialize_frm.forEach(obj=>{
        if(obj.value!=false||obj.value.length>0){
          finalFormValue.push(obj);
        }
     });

      var data ={
        promoId: window.mepaConfig.promoId,
        form: finalFormValue
      }
      if(this.googleReCaptchaResponse){
         this.isLoading = true;
         this.onlineFormServices.postDrawPersistResponse(this.$session.get('token'), data).then(response=>{
            this.isLoading = false;
            if(response.data.success){
              this.showForm = false;
              this.backendErrorMsg = null;
              if(response.data.token){
                 this.$session.set('token',response.data.token);
              }
              if(response.data.successMessage){
                this.successMsg = response.data.successMessage;
              }
            }
          }).catch(e =>{
            this.isLoading =false;
            this.reloadCaptcha();
            if(e.response){
              this.getBackendErrorMsg(e.response);
            }
          });
      }
    })
  },

  async getBackendErrorMsg(response){
      let isExistErrorMsg = false;
          if(response.data){
            if(response.data.errors){
               if(response.data.errors[0]){
                  if(response.data.errors[0].message){
                     isExistErrorMsg = true;
                     this.successMsg = null;
                     this.backendErrorMsg = response.data.errors[0].message;
                  }
               }
            }
          }
        
        if(!isExistErrorMsg){
          this.successMsg = null;
          this.backendErrorMsg = window.mepaConfig.apiLoginErr;
        }
  },

  //GOOGLE RECAPTCHA
  async onVerify(response) {
      this.googleReCaptchaResponse = response;
  },
  
  async onExpired() {
      this.reloadCaptcha();
  },
  
  async reloadCaptcha() {
    this.$refs.recaptcha.reset();
  },
  
  //HELPERS
  async defineCheckBox(key){
     if(!this.model[key]){
        this.model[key] = [];
     }
     setTimeout(function(){ 
       return true;
      }, 30);
  },

  async updateErrorMessage(params, errorType, message){
    let e={};
    e[errorType] = message;
    this.dict.custom[params] = e;
    VeeValidate.Validator.localize('sr', this.dict);
    return null;
  },

  setDateRangeDays (from, to) {
    let dateFrom = new Date(from);
    let dateTo = new Date(to);
    if(dateFrom<dateTo){
      let temp = dateFrom;
      dateFrom = dateTo;
      dateTo = temp;
    }
    let dateRange = {
      from: dateFrom,
      to: dateTo
    }
    return dateRange;
  },

  //COOKIE CONFIG
  setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + ";secure path=/ ";
  },

  getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0){
            return c.substring(nameEQ.length,c.length);
          } 
      }
      return null;
  },

  eraseCookie(name) {   
      document.cookie = name+'=;secure';  
  }
}
}
</script>




// WEBPACK FOOTER //
// src/online-form/DrawOnlineForm.vue